import type { Severity, TriageStatus } from '@/types';

export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const then = new Date(iso).getTime();
  const secs = Math.max(0, Math.round((Date.now() - then) / 1000));
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.round(hrs / 24)}d ago`;
}

export const severityColor: Record<Severity, string> = {
  error: '#e5484d',
  warning: '#f5a623',
  info: '#4a90e2',
};

export const statusLabel: Record<TriageStatus, string> = {
  new: 'New',
  acknowledged: 'Acknowledged',
  investigating: 'Investigating',
  assigned: 'Assigned',
  resolved: 'Resolved',
  wont_fix: "Won't fix",
};

export const statusColor: Record<TriageStatus, string> = {
  new: '#e5484d',
  acknowledged: '#f5a623',
  investigating: '#4a90e2',
  assigned: '#8b5cf6',
  resolved: '#30a46c',
  wont_fix: '#6b7280',
};
